
const user = {
  state: {
    name: '',
    avatar: '',
  },
};

export default user;
